import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';

import { LOCATION_TYPES, GEO_REFERENCE_TYPES } from '../../../constants/areas';
import {
  clearLayers,
  hasArea,
  hasZones,
  clearTags,
  drawArea,
  drawZones,
  drawLocations,
  drawSuperTags,
  drawGeoJson
} from '../../../utils/mapgl';
import MapGL from '../../data/mapgl/MapGL';

class TagsMap extends Component {
  state = {
    selectedTag: null,
    prevArea: null
  };

  onLoad = map => {
    let {
      area,
      zones,
      locations,
      tags,
      superTags,
      selectedTag,
      onLocationClick,
      onSuperTagClick,
      defaultGeoJson
    } = this.props;
    let isNewArea = this.state.prevArea !== area.id;
    let isGeoReferenced =
      area && area.geoReferenced === GEO_REFERENCE_TYPES.YES;
    if (isNewArea) {
      clearLayers(map);
      this.setState({ prevArea: area.id });
    } else if (isGeoReferenced) {
      clearTags(map);
    }
    let isNewSelectedTag = this.state.selectedTag !== selectedTag;
    if (isNewSelectedTag) {
      superTags.forEach(tag => {
        if (tag.id === selectedTag) {
          map.flyTo({ center: [tag.longitude, tag.latitude] });
        }
      });
      this.setState({ selectedTag });
    }
    let existarea = hasArea(map);
    
    let areazones = zones && area.id in zones ? zones[area.id] : []
    let existzones = hasZones(map, areazones[0]);
    
    if(!existarea){
      drawArea(map, area, isNewArea);
    }
    
    if(!existzones){
      drawZones(
        map,
        areazones
      );
    }    
    tags = (tags || []).filter(tag => !selectedTag || tag.id === selectedTag);


    if(!isGeoReferenced){
      if(defaultGeoJson.length){
        drawGeoJson(map, defaultGeoJson);
        return;
      }
      //moved out of drawZones
      let filteredTags = [...tags];
      let locationTags = filteredTags.reduce((filteredTags, tag) => {
        if (tag.location && tag.location.id) {
          if (tag.location.id in filteredTags) {
            filteredTags[tag.location.id].push(tag);
          } else {
            filteredTags[tag.location.id] = [tag];
          }
        }
        return filteredTags;
      }, {});

      drawLocations(map, areazones, locations, locationTags, onLocationClick);
    }

    if (isGeoReferenced) {
      superTags = (superTags || []).filter(
        tag => {
          return (!selectedTag) || tag.id === selectedTag;
      });
      drawSuperTags(map, superTags, onSuperTagClick);
    }
  };

  render() {
    let { area, options } = this.props;
    let isGeoReferenced =
      area && area.geoReferenced === GEO_REFERENCE_TYPES.YES;
    if (
      !area ||
      isEmpty(area) ||
      (area.location === LOCATION_TYPES.OUTDOOR && !area.polygon) ||
      (area.location === LOCATION_TYPES.INDOOR &&
        !isGeoReferenced &&
        (!area.indoorMapping ||
          !area.indoorMapping.nwCorner ||
          !area.indoorMapping.seCorner))
    ) {
      return false;
    }
    if (!isEmpty(area.indoorMapping)) {
      let { nwCorner, seCorner } = area.indoorMapping;
      options = {
        maxBounds: [
          [nwCorner.lng - 0.5, seCorner.lat - 0.2],
          [seCorner.lng + 0.5, nwCorner.lat + 0.2]
        ],
        center: [0, 0],
        zoom: 12,
        minZoom: 10,
        maxZoom: 14,
        ...options
      };
    }
    if (!isGeoReferenced) {
      return (
        <MapGL
          key="nonGeoMap"
          type="clear"
          onLoad={this.onLoad}
          onUpdate={this.onLoad}
          onClick={this.props.onClick}
          onMove={this.props.onMove}
          options={options}
        />
      );
    }
    return (
      <MapGL
        key="geoMap"
        type="default"
        onLoad={this.onLoad}
        onUpdate={this.onLoad}
        onClick={this.props.onClick}
        onMove={this.props.onMove}
        options={options}
        showSuperTagLegend={true}
      />
    );
  }
}

export default TagsMap;



// WEBPACK FOOTER //
// ./src/components/data/tagsmap/TagsMap.js